<template>
	<div>
		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%" width="350">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
				<v-list-item>
					<v-autocomplete hide-details="auto" v-model="settings.filters.brand" :items="brands" label="Brand" item-value="value" item-text="name" clearable></v-autocomplete>
				</v-list-item>
				<v-list-item>
					<v-treeview
						v-if="getSettings.categories && getSettings.categories.length > 0 && langDefault"
						:items="getSettings.categories"
						:open.sync="open"
						selectable
						:selection-type="selectionType"
						v-model="findParant"
						return-object
						dense
						selected-color="primary"
						@input="filterCheck"
					>
						<template v-slot:prepend="{ item }">
							<span>{{ _.find(item.trans, { lang: langDefault }).name }}</span>
						</template>
					</v-treeview>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.items.items') }} {{ listing.name }}</v-toolbar-title>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->
								<v-btn text to="/setting/listing" exact>
									<v-icon>mdi-arrow-collapse-left</v-icon>
								</v-btn>
								<v-btn text @click="exportAsync('listings', 'csv', { listing: getListing._id })" exact>
									<v-icon>mdi-arrow-collapse-down</v-icon>
								</v-btn>
								<!--<v-btn text @click="toggleDrawerSort">
                                    <v-icon>mdi-sort</v-icon>
                                </v-btn>-->
								<!-- <v-divider vertical></v-divider>-->
								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>

								<!-- <v-divider vertical></v-divider>-->
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text>
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<!--<v-list-item @click="getCategoryMagento" v-if="magento">
                                            <v-list-item-icon>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                                <v-list-item-title>Importa da Magento</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>-->
										<v-list-item @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi prodotto</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>

						<v-card v-if="selected.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selected.length }}
									<span v-if="selected.length == 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="addItem"> Aggiungi al listino </v-tab>

								<v-tab @click="deleteItem"> elimina dal listino </v-tab>
								<!--<v-tab :href="this.getUrl+'categories/download?token='+this.getToken+'&search='+this.searchfield+'&categories='+this.settings.filters.categories+'&selected='+this.selected">
                                    Download
                                </v-tab>-->
							</v-tabs>
						</v-card>

						<v-data-table
							v-model="selectedall"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							@input="toggle"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item.indice"
							show-select
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"
                            :class="{mobile: isMobile}"-->

							<!-- <template slot="headers" slot-scope="props">
                                 <tr>
                                     <th>
                                         <v-checkbox
                                                 primary
                                                 hide-details
                                                 @click.native="toggleAll"
                                                 :input-value="props.all"
                                                 :indeterminate="props.indeterminate"
                                         ></v-checkbox>
                                     </th>
                                     <th v-for="header in props.headers" :key="header.text"
                                         :class="['column sortable', settings.pagination.descending ? 'desc' : 'asc', header.value === settings.pagination.pagination.sortBy ? 'active' : '']"
                                         @click="changeSort(header.value)"
                                     >
                                         <v-icon>arrow_upward</v-icon>
                                         {{ header.text }} f
                                     </th>
                                 </tr>
                             </template>-->
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="listing-item-cards">
									<tr v-for="(item, index) in items" :key="item.indice || index">
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<key-value-card
												:title="item.trans ? item.trans.name : ''"
												:fields="campiCard(item)"
												:image="createImage(item) || immagineVuota"
												:image-fallback="immagineVuota"
											>
												<template v-slot:actions>
													<v-checkbox class="mt-0 pt-0 mr-2" v-model="selected" :value="item.indice" color="primary" hide-details></v-checkbox>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Status</span>
													<v-switch v-model="item.statusRules" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Prezzo</span>
													<span>
														<span class="font-weight-bold">{{ item.variants.sell }}</span>
														<span v-if="item.variants.originSell" class="red--text ml-1">{{ item.variants.originSell }}</span>
														<v-btn fab icon x-small @click="changeDiscount(item)"><v-icon>mdi-cog-outline</v-icon></v-btn>
													</span>
												</div>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Prezzo + iva</span>
													<span>
														<span class="font-weight-bold">{{ item.variants.pricevat }}</span>
														<span v-if="item.variants.originPricevat" class="red--text ml-1">{{ item.variants.originPricevat }}</span>
														<v-btn fab icon x-small @click="dialog = true"><v-icon>mdi-cog-outline</v-icon></v-btn>
													</span>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="`${item.id}${_.random(1, 10000)}`">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->
										<td>
											<v-checkbox class="mt-0" v-model="selected" :value="item.indice" color="primary" hide-details></v-checkbox>
										</td>
										<td>
											<v-switch v-model="item.statusRules" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
										</td>

										<td>
											{{ item.created | moment('DD/MM/YYYY') }}
										</td>
										<td>
											<v-img class="mt-1 mb-1" max-height="150" max-width="150" :ref="index" :src="createImage(item)" @error="imageUrlAlt(index)"></v-img>

											<!---->
										</td>
										<td>
											<span v-if="item.brand && item.brand.trans">
												{{ _.find(item.brand.trans, { lang: langDefault }).name }}
											</span>
										</td>
										<td>
											<template v-for="el of item.categories">
												<v-chip v-if="el.trans" small class="ma-1">
													{{ _.find(el.trans, { lang: langDefault }).name }}
												</v-chip>
											</template>
										</td>
										<td>{{ item.model }}</td>
										<td v-if="item.trans">{{ item.trans.name }}</td>
										<td>
											<div v-for="element in item.variants.variants" v-if="item.variante">
												<b>{{ _.find(_.find(element, { typology: 'variant' }).trans, { lang: langDefault }).name }}</b>

												<!--{{ _.find(element,{typology:'value'}).trans}}-->
												{{ _.find(_.find(element, { typology: 'value' }).trans, { lang: langDefault }).name }}
											</div>
										</td>

										<td>{{ item.variants.sku }}</td>
										<td>{{ item.variants.ean }}</td>
										<td>{{ item.variants.qt }}</td>
										<td>
											<span v-if="item.variants.unit">
												{{ _.find(item.variants.unit.trans, { lang: langDefault }).unit }}
											</span>
										</td>
										<td>{{ item.variants.buy }}</td>
										<td>{{ item.variants.qtunit }}</td>
										<td class="wspace">
											<!-- <v-text-field hide-details="auto"
                                            :value="item.variants.sell"
                                            type="number"
                                            :append-outer-icon="'mdi-content-save-outline'"
                                            @input="changeSellPrice(item,$event)"
                                            class="wspace"

                                        ></v-text-field>-->
											<!--
                                         @click:append-outer=""

                                          v-model="item.variants.sell"
                                        -->
											{{ item.variants.sell }} <v-btn fab icon x-small @click="changeDiscount(item)"><v-icon>mdi-cog-outline</v-icon></v-btn>
											<p style="color: red">{{ item.variants.originSell }}</p>
										</td>
										<td>
											<span v-if="item.vat">
												{{ item.vat.vat }}
											</span>
										</td>
										<td>{{ item.variants.discount }} %</td>
										<td>
											{{ item.variants.pricevat }} <v-btn fab icon x-small @click="dialog = true"><v-icon>mdi-cog-outline</v-icon></v-btn>
											<p style="color: red">{{ item.variants.originPricevat }}</p>
										</td>
										<td>
											<span v-if="item.variants.currency">
												{{ item.variants.currency.id }}
											</span>
										</td>
										<!--td>{{ item.id }}</td-->
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
					<!--<v-btn
                            fab
                            bottom
                            right
                            color="secondary"
                            dark
                            fixed
                            @click.prevent="openNew()"
                    >

                        <v-icon>add</v-icon>
                    </v-btn>-->
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormDuplicate v-if="operation == 'FormDuplicate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormDuplicate>
			<FormEdit v-if="operation == 'FormEdit'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation == 'FormCreate'" :key="componentKey" @event="getDataFromApi"></FormCreate>
			<FormFile v-if="operation == 'FormFile'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormFile>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando la categoria non potrai più ripristinarla. I prodotti associati resteranno senza categoria </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialog" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">{{ form.name }}</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="6" md="4">
								<v-text-field hide-details="auto" label="Prezzo" disabled :value="form.originPrice"></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field hide-details="auto" label="Vat" disabled :value="form.vat"></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field hide-details="auto" label="Prezzo +iva" disabled :value="form.originPricevat"></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field hide-details="auto" label="Prezzo" @input="changeSellPrice($event)" :value="form.price"></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field hide-details="auto" label="Sconto" @input="changeDiscountPrice($event)" :value="form.discount"></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field hide-details="auto" label="Prezzo +iva" @input="changeSellPriceVat($event)" :value="form.pricevat"></v-text-field>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialog = false"> Close </v-btn>
					<v-btn color="blue darken-1" text @click="changeValueListing()"> Save </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { openWithReturn } from '@/components/core/pageReturn';
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
import { discount, discountPercent } from '../../Helper';

Vue.use(VuetifyDraggableTreeview);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import KeyValueCard from '@/components/core/KeyValueCard.vue';

const FormCreate = () => import('@/components/items/Create.vue');
const FormEdit = () => import('@/components/items/Edit.vue');
const FormFile = () => import('@/components/items/File.vue');
const FormDuplicate = () => import('@/components/items/Duplicate.vue');

export default {
	name: 'Items',
	data() {
		return {
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					categories: [],
					brand: {},
				},
				options: {
					sortBy: ['listing'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],
			searchfield: '',
			selected: [],
			selectedall: [],
			total: 0,
			headers: [
				{ text: 'Status', value: 'is_active', sortable: false },
				{ text: 'Creazione', value: 'created', sortable: true },
				{ text: 'Immagine', value: 'trans.name', sortable: false },
				{ text: 'Brand', value: 'model', sortable: false },
				{ text: 'Categoria', value: 'model', sortable: false },
				{ text: 'Modello', value: 'model' },
				{ text: 'Nome', value: 'trans.name' },
				{ text: 'Variante', value: 'model', sortable: false },
				{ text: 'Sku', value: 'variants.sku' },
				{ text: 'Ean', value: 'variants.ean' },
				{ text: 'Quantità', value: 'variants.qt' },
				{ text: 'Unità', value: 'variants.buy' },
				{ text: 'Prezzo acquisto', value: 'variants.buy' },
				{ text: 'Quantità unità', value: 'variants.qtunit' },
				{ text: 'Prezzo ', value: 'variants.sell' },
				{ text: 'Vat ', value: 'vat.vat' },
				{ text: 'Sconto ', value: 'variants.discount' },
				{ text: 'Prezzo + iva', value: 'variants.sell' },
				{ text: 'Valuta', value: 'sell', sortable: false },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			langDefault: '',
			brands: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			listing: {},
			dialog: false,
			form: {
				price: 0,
				pricevat: 0,
				name: '',
				discount: 0,
				vat: 0,
				originPrice: 0,
				originPricevat: 0,
				listing: '',
				_id: '',
				uuid: '',
			},
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return (value = value.toFixed(2));
		},
	},
	async mounted() {
		var listing = await this.getDetailListing(this.$route.params.id);
		this.listing = listing.data.data;
	},
	async created() {
		this.setDialog(false);
		this.setExistFilter(true);
		//this.linkdownload = `${this.getUrl}categories/download`
		var data = await this.fetchSetting();
		this.langDefault = _.find(data.languages, { default: true }).lang;
		var result = await this.fetchLists({});
		var Abrands = [];
		_.forEach(result.data, res => {
			var single = _.find(res.trans, { lang: this.langDefault }).name;
			Abrands = [{ value: { _id: res._id, trans: res.trans }, name: single }, ...Abrands];
		});
		this.brands = _.orderBy(Abrands, ['name'], ['asc']);
	},
	watch: {
		selectedLength(val, oldVal) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		settings: {
			handler: function (val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] != '') {
					var outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.options.page == this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.options.page;
				this.getDataFromApi();
			},
			deep: true,
		},
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		FormCreate,
		FormEdit,
		FormFile,
		FormDuplicate,
		KeyValueCard,
		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// segnaposto per le miniature mancanti nella card
		immagineVuota() {
			return require(`@/assets/images/picture.svg`);
		},
		selectedLength() {
			return this.selected.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'items/getIndex',
			getItems: 'listings/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'listings/getSortBy',
			getSortDesc: 'listings/getSortDesc',
			getCategoriesTree: 'categories/getCategoriesTree',
			getCategoriesChildrean: 'categories/getCategoriesChildrean',
			getSettings: 'settings/getSetting',
			getListing: 'listings/getListing',
		}),
		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function (old, newvalue) {
				return this.clippedOrder;
			},
			set: function (newvalue) {
				return this.clippedOrder;
			},
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'items/setItems',
			setItem: 'items/setItem',
			setListing: 'listings/setListing',
			setIndex: 'items/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'listings/asyncFetchItems',
			deleteItems: 'items/deleteItems',

			destroyData: 'listings/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			fetchLists: 'brands/fetchLists',

			setUpdateStatusItem: 'listings/setUpdateStatusItem',
			setChangeValueListing: 'listings/setChangeValueListing',
			// 'setUpdateStatusItemVariant': 'items/setUpdateStatusItemVariant',
			getDetailListing: 'listings/getDetailListing',
			addItemsToListing: 'listings/addItemsToListing',

			//'resetMessages' : 'settings/resetMessages'
		}),
		// nome tradotto nella lingua di default (brand, categorie, varianti)
		nomeLingua(trans, key = 'name') {
			const found = _.find(trans, { lang: this.langDefault });
			return found ? found[key] : '';
		},
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			const variants = item.variants || {};
			let variante = '';
			if (item.variante) {
				variante = _.map(variants.variants, element => {
					const tipo = _.find(element, { typology: 'variant' });
					const valore = _.find(element, { typology: 'value' });
					return `${tipo ? this.nomeLingua(tipo.trans) : ''} ${valore ? this.nomeLingua(valore.trans) : ''}`.trim();
				}).join(', ');
			}
			return [
				{ label: 'Creazione', value: item.created ? this.$moment(item.created).format('DD/MM/YYYY') : '' },
				{ label: 'Brand', value: item.brand && item.brand.trans ? this.nomeLingua(item.brand.trans) : '' },
				{ label: 'Categoria', value: _.filter(_.map(item.categories, el => (el.trans ? this.nomeLingua(el.trans) : ''))).join(', ') },
				{ label: 'Modello', value: item.model },
				{ label: 'Variante', value: variante },
				{ label: 'Sku', value: variants.sku },
				{ label: 'Ean', value: variants.ean },
				{ label: 'Quantità', value: variants.qt, strong: true },
				{ label: 'Unità', value: variants.unit ? this.nomeLingua(variants.unit.trans, 'unit') : '' },
				{ label: 'Prezzo acquisto', value: variants.buy },
				{ label: 'Quantità unità', value: variants.qtunit },
				{ label: 'Vat', value: item.vat ? item.vat.vat : '' },
				{ label: 'Sconto', value: variants.discount !== undefined && variants.discount !== null ? `${variants.discount} %` : '' },
				{ label: 'Valuta', value: variants.currency ? variants.currency.id : '' },
			];
		},
		changeDiscount(item) {
			this.dialog = true;
			this.form.price = item.variants.sell;
			this.form.pricevat = item.variants.pricevat;
			this.form.name = item.trans.name;
			this.form.discount = +item.variants.discount;
			this.form.vat = +item.vat.vat;
			this.form.originPrice = +item.variants.originSell;
			this.form.originPricevat = +item.variants.originPricevat;
			this.form._id = item._id;
			this.form.uuid = item.variants.uuid;
			this.form.listing = this.getListing._id;
		},
		async changeSellPrice(event) {
			var vat = this.form.vat / 100 + 1;
			this.form.price = +event;
			this.form.pricevat = (this.form.price * vat).toFixed(3);
			this.form.discount = await discountPercent(this.form.originPrice, this.form.price);
		},
		async changeDiscountPrice(event) {
			var prices = await discount(this.form.originPrice, this.form.originPricevat, this.form.vat, +event);
			this.form.price = +prices.discountPrice;
			this.form.pricevat = +prices.discountPriceVat;
			this.form.discount = +event;
		},
		async changeSellPriceVat(event) {
			var vat = this.form.vat / 100 + 1;
			this.form.pricevat = +event;
			this.form.price = (this.form.pricevat / vat).toFixed(3);
			this.form.discount = await discountPercent(this.form.originPrice, this.form.price);
		},
		imageUrlAlt(index) {
			// console.log("E",require(`@/assets/images/picture.svg`))
			//  console.log("EVENT",event)
			//   event.target.src = require(`@/assets/images/picture.svg`)
			//console.log(this.$refs[index])
			this.$refs[index][0].src = require(`@/assets/images/picture.svg`);
		},
		filterCheck(event) {
			var dot = _.map(event, 'id');

			this.settings.filters.categories = dot;
		},
		createImage(item) {
			var image = '';

			if (_.size(item.images) > 0) {
				var first = _.first(item.images);

				if (_.size(first.sizes) > 0) {
					var firstimage = _.first(first.sizes);
					image = firstimage.value;
				}
			}
			var images = item.images;
			// image = require(`@/assets/images/picture.svg`);

			//console.log("i",images)
			if (_.size(item.variants) > 0) {
				_.forEach(item.variants.variants, variant => {
					var value = _.find(variant, { typology: 'value' });

					_.forEach(images, img => {
						_.forEach(img.variants, el => {
							var check = _.find(el, { _id: value._id });
							if (check) {
								var first = _.first(img.sizes);
								image = first.value;
								return false;
								// console.log("dentro")

								//console.log("FOUNF",first)
							}
						});
					});
				});
			}
			try {
				return image;
			} catch (e) {
				return require(`@/assets/images/picture.svg`);
			}
			//return image;
			//require(`@/assets/images/picture.svg`)
		},
		toggle(event) {
			if (_.size(this.selectedall) == 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] != -1) {
					this.selected = [];
					_.forEach(this.getItems, cat => {
						this.selected.push(cat.indice);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		download() {
			return 'nocors/listings/items/download?token=' + this.getToken + '&listing=' + this.getListing._id;
		},
		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		changeStatus(item) {
			try {
				this.setPreload(true);

				let items = this.setUpdateStatusItem({ _id: item._id, variants: item.variants.uuid, is_active: item.statusRules, listing: this.getListing._id }).then(result => {
					//this.total = result.total
					//this.items = result.data.data
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Update successfully';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					/*if (result.data.data.ok) {
                            this.snackbar.color = "success";
                            this.snackbar.text = "Update successfully";
                            this.snackbar.snackbar = true;
                            this.snackbar.mode = 'multi-line';
                            this.snackbar.timeout = 5000;
                        }*/
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},
		changeValueListing(item) {
			try {
				this.setPreload(true);

				let items = this.setChangeValueListing(this.form).then(result => {
					this.dialog = false;
					//this.total = result.total
					//this.items = result.data.data

					this.getDataFromApi().then(result => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					});
					this.setPreload(false);
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async duplicateItem() {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormDuplicate';
			var item = _.find(this.getItems, search => {
				return search._id == this.selected[0];
			});
			// la scheda prodotto e' una pagina: ci si va e, salvando o annullando, si torna qui
			if (!item) return;
			this.setMessages();
			openWithReturn(this, { path: `/items/${item._id}/duplicate` }, { label: 'Torna al listino' });
		},
		async editItem() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormEdit';
			var item = _.find(this.getItems, search => {
				return search._id == this.selected[0];
			});
			// la scheda prodotto e' una pagina: ci si va e, salvando o annullando, si torna qui
			if (!item) return;
			this.setMessages();
			openWithReturn(this, { path: `/items/${item._id}` }, { label: 'Torna al listino' });
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormCreate';

			// la scheda prodotto e' una pagina: ci si va e, salvando o annullando, si torna qui
			this.setMessages();
			openWithReturn(this, { path: '/items/new' }, { label: 'Torna al listino' });
			/*Vue.component(
                    'FormEdit',
                    // A dynamic import returns a Promise.
                    () => import('@/components/orders/Edit.vue')
                )*/
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 2) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;
				let items = this.fetchItems(this.settings);
				items
					.then(result => {
						this.total = result.total;
						//this.items = result.data.data
						this.setPreload(false);
						this.selected = [];
						this.selectedall = [];
					})
					.then(() => {
						/*this.getFetchTreeCategory().then(() => {

                            var find =  _.orderBy(this.getCategoriesTree, 'parent.id', 'asc');

                            if(_.size(find)>0) {
                                if (_.size(find) > 1) {
                                    this.firstLevel = _.filter(this.getCategoriesTree, filter => {
                                        return filter.parent.id == find[0].parent.id
                                    })
                                    // console.log(this.firstLevel)
                                }

                                this.getNestedCategory(find[0].parent.id).then(() => {

                                    this.items = this.getCategoriesChildrean
                                })
                            }


                        })*/
					});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    var response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},
		importItemConfirmShopify(item) {
			this.dialogconfirmImport = true;
		},
		addItem() {
			/* this.messages = [];
                var paypload = []
                _.forEach(this.selected, cat => {
                    var index = _.find(this.getItems, {indice : cat})

                    if (index) {
                        paypload.push(index)
                    }

                })
                console.log(paypload)
                return*/
			this.setPreload(true);
			var items = this.getListing.items;

			_.forEach(this.selected, el => {
				var split = _.split(el, '#');
				var check = _.find(this.getListing.items, { _id: split[0], id: split[1] });
				if (!check) {
					items.push({ _id: split[0], id: split[1] });
				}
			});

			this.addItemsToListing({ listing: this.getListing._id, values: items })
				.then(data => {
					this.setPreload(false);
					this.getDataFromApi().then(res => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
		},
		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},

		confirmDelete() {
			this.dialogconfirm = false;
			let url = 'items/delete';

			this.messages = [];
			var paypload = [];
			_.forEach(this.selected, cat => {
				var index = _.find(this.getItems, { _id: cat });

				if (index) {
					paypload.push(index);
				}
			});

			this.deleteItems(paypload)
				.then(data => {
					this.setPreload(false);
					this.getDataFromApi().then(res => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.listing-item-cards,
.listing-item-cards tr {
	display: block;
	width: 100%;
}
.listing-item-cards tr,
.listing-item-cards tr:hover {
	background: transparent !important;
}
.listing-item-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.listing-item-cards tr:first-child td {
	padding-top: 12px !important;
}
.listing-item-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.listing-item-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
